/* eslint-disable no-console */
import { takeLatest, put, select } from 'redux-saga/effects';
import { compact } from 'lodash';
import { loadHistoryRes, loadHistoryErr, loadDisplayUsersHistory } from '../actions/historyActions';
import getHistoryApi from '../api/historyApi';
import { getUsersApi } from '../api/userApi';
import { LOAD_HISTORY } from '../types/historyTypes';

const getHistory = state => state.history;

// L O A D   H I S T O R Y
function* loadHistorySaga(action) {
    const { offset, limit } = yield select(getHistory);

    try {
        const params = { offset, limit };
        params.sort_by = JSON.stringify({ created_at: -1 });

        let api = process.env.REACT_APP_REST;

        if (['order', 'customer', 'quote', 'email_template'].includes(action.stream.group)) {
            api = process.env.REACT_APP_REST_ORDERS;
        }

        const result = yield getHistoryApi(action.stream, params, api);

        if (result.status === 200) {
            const userIDS = compact((result.data?.hits || []).map(u => u.user_id));
            const userParams = { filter: JSON.stringify({ _id: userIDS }) };

            const userResult = yield getUsersApi(userParams);
            yield put(loadDisplayUsersHistory(userResult.data.hits));

            yield put(loadHistoryRes(result.data));
        }
    } catch (e) {
        console.log(e);
        yield put(loadHistoryErr());
    }
}

export default function* loadHistoryWatcher() {
    yield takeLatest(LOAD_HISTORY, loadHistorySaga);
}
// L O A D   H I S T O R Y
